import { RouteLocationNormalized } from "vue-router"
import { RouterMeta } from ".";
import NProgress from "../utils/progress"
import { canUserAccess, initAppData } from "../common/commonHelper";
import store from "../store/store";

let beforeToNext = async function(to:RouteLocationNormalized){
    await initAppData();
    if(to.meta.name !=null && to.meta.isAuth && to.meta.name != RouterMeta.login.name){
        if(!canUserAccess()){
            store.commit("SetCurrentRoute",{
                "routeInfo":{ 
                    human:false,
                    name:to.meta.name,
                    params:to.params
                },
                "routePath":to.fullPath
            });
            return { name: RouterMeta.login.name };
        }
        else{
            NProgress.start();
            if(store.state.hasInitMenu){
                let path = to.fullPath;
                let index = store.state.flatMenuItems.findIndex(x=>x.Path == path);
                if(index>-1){
                    store.commit("SetCurrentModule", store.state.flatMenuItems[index].CurrentModule)
                } 
            }
            return true;
        }
    }
    else{
        return true;
    }
}

let afterToNext = function(to:RouteLocationNormalized){
    if(to.meta.name != RouterMeta.login.name){
        NProgress.done();
    }
}

export { beforeToNext, afterToNext }